import {
  ArrowLeftIcon,
  ArrowRightIcon,
  Box,
  CheckIcon,
  GKButton,
  GKModal,
  Grid2,
  List,
  ListItem,
  Typography,
} from "components";
import { useState } from "react";

interface Props {
  open: boolean;
  setOpen: (value: boolean) => void;
}

const TelegramSetupModal = ({ open, setOpen }: Props) => {
  const [activeStep, setActiveStep] = useState(0);

  const steps = [
    {
      title: "Step 1",
      img: "step-1.png",
      description: (
        <Grid2 container spacing={1}>
          <Grid2 size={12}>
            <Typography
              display={"flex"}
              alignItems={"center"}
              gap={0.5}
              fontSize={14}
              fontWeight={500}
              color="var(--grey-900)"
            >
              Open
              <a
                href="https://web.telegram.org/a/"
                target="_blank"
                rel="noopener noreferrer"
                style={{ color: "var(--primary-900)" }}
              >
                Telegram messenger,
              </a>{" "}
              sign in to your account or create a new one.
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <Typography fontSize={14} fontWeight={500} color="var(--grey-900)">
              1. In the search bar, search for{" "}
              <span style={{ color: "var(--grey-900)", fontWeight: 600 }}>
                @botfather
              </span>
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <img
              src={`/TelegramStepsImg/${"step-1.png"}`}
              alt=""
              draggable={false}
              style={{
                width: "100%",
                borderRadius: "8px",
                border: "1px solid var(--neutral-100)",
              }}
            />
          </Grid2>
        </Grid2>
      ),
    },
    {
      title: "Step 2",
      img: "step-2.png",
      description: (
        <Grid2 container spacing={1}>
          <Grid2 size={12}>
            <Typography fontSize={14} fontWeight={500} color="var(--grey-900)">
              2. Select the botfather channel and click{" "}
              <span style={{ color: "var(--grey-900)", fontWeight: 700 }}>
                Start
              </span>{" "}
              button.
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <img
              src={`/TelegramStepsImg/${"step-2.png"}`}
              alt=""
              draggable={false}
              style={{
                width: "100%",
                borderRadius: "8px",
                border: "1px solid var(--neutral-100)",
              }}
            />
          </Grid2>
        </Grid2>
      ),
    },
    {
      title: "Step 3",
      img: "step-3.png",
      description: (
        <Grid2 container spacing={1}>
          <Grid2 size={12}>
            <Typography fontSize={14} fontWeight={500} color="var(--grey-900)">
              3. Once you click Start, You’ll receive a list of controls to
              create your bot.
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <img
              src={`/TelegramStepsImg/${"step-3.png"}`}
              alt=""
              draggable={false}
              style={{
                width: "100%",
                borderRadius: "8px",
                border: "1px solid var(--neutral-100)",
              }}
            />
          </Grid2>
        </Grid2>
      ),
    },
    {
      title: "Step 4",
      img: "step-4.png",
      description: (
        <Grid2 container spacing={1}>
          <Grid2 size={12}>
            <Typography fontSize={14} fontWeight={500} color="var(--grey-900)">
              4. Type or click “
              <span style={{ color: "var(--grey-900)", fontWeight: 700 }}>
                /newbot
              </span>
              ” to begin.
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <img
              src={`/TelegramStepsImg/${"step-4.png"}`}
              alt=""
              draggable={false}
              style={{
                width: "100%",
                borderRadius: "8px",
                border: "1px solid var(--neutral-100)",
              }}
            />
          </Grid2>
        </Grid2>
      ),
    },
    {
      title: "Step 5",
      img: "step-5.png",
      description: (
        <Grid2 container spacing={1}>
          <Grid2 size={12}>
            <Typography fontSize={14} fontWeight={500} color="var(--grey-900)">
              5. You’ll be prompted to choose a name for your bot
              <span style={{ color: "var(--grey-900)", fontWeight: 700 }}>
                name for your bot
              </span>
              . (For example: MakeProfit_2025)
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <List sx={{ p: 0, listStyleType: "disc", pl: 2 }}>
              <ListItem sx={{ display: "list-item", p: 0 }}>
                <Typography
                  fontSize={14}
                  fontWeight={500}
                  color="var(--grey-900)"
                >
                  After setting the name, you’ll be asked to create a username
                  for your bot.
                </Typography>
              </ListItem>
            </List>
          </Grid2>
          <Box
            mt={1}
            sx={{
              background: "var(--yellow-100)",
              borderRadius: "8px",
              p: "8px",
            }}
          >
            <Typography
              component="div"
              sx={{
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              <Typography
                fontSize={12}
                fontWeight={700}
                color="var(--neutral-700)"
                display="inline"
              >
                Note:{" "}
              </Typography>
              <Typography
                fontSize={12}
                fontWeight={500}
                color="var(--neutral-700)"
                display="inline"
              >
                The username must end with the word bot; e.g.{" "}
                <Typography
                  fontStyle="italic"
                  display="inline"
                  fontSize={12}
                  fontWeight={500}
                  color="var(--neutral-700)"
                >
                  makeprofitbot_2025_bot.
                </Typography>
              </Typography>
            </Typography>
          </Box>
          <Grid2 size={12}>
            <img
              src={`/TelegramStepsImg/${"step-5.png"}`}
              alt=""
              draggable={false}
              style={{
                width: "100%",
                borderRadius: "8px",
                border: "1px solid var(--neutral-100)",
              }}
            />
          </Grid2>
        </Grid2>
      ),
    },
    {
      title: "Step 6",
      img: "step-6.png",
      description: (
        <Grid2 container spacing={1}>
          <Grid2 size={12}>
            <Typography fontSize={14} fontWeight={500} color="var(--grey-900)">
              6. Once done, BotFather will send you the following bot details:
            </Typography>
            <Typography
              ml={2}
              fontSize={14}
              fontWeight={500}
              color="var(--grey-900)"
            >
              <span style={{ color: "var(--grey-900)", fontWeight: 600 }}>
                Copy the API key
              </span>{" "}
              that is generated under &quot;Use this token to access the HTTP
              API&quot;
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <img
              src={`/TelegramStepsImg/${"step-6.png"}`}
              alt=""
              draggable={false}
              style={{
                width: "100%",
                borderRadius: "8px",
                border: "1px solid var(--neutral-100)",
              }}
            />
          </Grid2>
        </Grid2>
      ),
    },
    {
      title: "Step 7",
      img: "step-7.png",
      description: (
        <Grid2 container spacing={1}>
          <Grid2 size={12}>
            <Typography fontSize={14} fontWeight={500} color="var(--grey-900)">
              7. Open Gridkey: Go to{" "}
              <span style={{ color: "var(--grey-900)", fontWeight: 600 }}>
                Settings → Integration & Setup → Telegram.
              </span>
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <img
              src={`/TelegramStepsImg/${"step-7.png"}`}
              alt=""
              draggable={false}
              style={{
                width: "100%",
                borderRadius: "8px",
                border: "1px solid var(--neutral-100)",
              }}
            />
          </Grid2>
        </Grid2>
      ),
    },
    {
      title: "Step 8",
      img: "step-8.png",
      img2: "step-88.png",
      description: (
        <Grid2 container spacing={1}>
          <Grid2 size={12}>
            <Typography fontSize={14} fontWeight={500} color="var(--grey-900)">
              8. Now fill the details in{" "}
              <span style={{ color: "var(--grey-900)", fontWeight: 600 }}>
                Setup Telegram
              </span>{" "}
              like below & click on{" "}
              <span style={{ color: "var(--grey-900)", fontWeight: 600 }}>
                Integrate button.
              </span>
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <img
              src={`/TelegramStepsImg/${"step-8.png"}`}
              alt=""
              draggable={false}
              style={{
                width: "100%",
                borderRadius: "8px",
                border: "1px solid var(--neutral-100)",
              }}
            />
          </Grid2>
          <Grid2 size={12}>
            <img
              src={`/TelegramStepsImg/${"step-88.png"}`}
              alt=""
              draggable={false}
              style={{
                width: "100%",
                borderRadius: "8px",
                border: "1px solid var(--neutral-100)",
              }}
            />
          </Grid2>
        </Grid2>
      ),
    },
    {
      title: "Step 9",
      img: "step-9.png",
      description: (
        <Grid2 container spacing={1}>
          <Grid2 size={12}>
            <Typography fontSize={14} fontWeight={500} color="var(--grey-900)">
              9. Click on the{" "}
              <span style={{ color: "var(--grey-900)", fontWeight: 600 }}>
                Bot Link
              </span>{" "}
              . This will open a chat of your bot, Click{" "}
              <span style={{ color: "var(--grey-900)", fontWeight: 600 }}>
                &quot;Start&quot;
              </span>{" "}
              to activate your bot.
            </Typography>
          </Grid2>
          <Grid2 size={12}>
            <img
              src={`/TelegramStepsImg/${"step-9.png"}`}
              alt=""
              draggable={false}
              style={{
                width: "100%",
                borderRadius: "8px",
                border: "1px solid var(--neutral-100)",
              }}
            />
          </Grid2>
          <Grid2 size={12}>
            <Typography
              mt={"24px"}
              fontSize={14}
              fontWeight={500}
              color="var(--grey-900)"
            >
              To integrate Gridkey with Telegram, navigate to:{" "}
              <span style={{ color: "var(--grey-900)", fontWeight: 600 }}>
                {" "}
                Basket → Profile → Edit Basket → Telegram tab,
              </span>{" "}
              where you&apos;ll find a step-by-step guide.
            </Typography>
          </Grid2>
        </Grid2>
      ),
    },
  ];

  return (
    <GKModal
      width={"849px"}
      maxHeight="calc(100vh - 200px)"
      minHeight="calc(100vh - 200px)"
      open={open}
      setOpen={setOpen}
      modalTitle={"Steps to Create Your Own Telegram Bot"}
      subTitle={
        <span style={{ color: "var(--neutral-500)" }}>
          Follow these simple steps to create your own Telegram bot in minutes.
        </span>
      }
      footer={
        <Grid2 container spacing={1}>
          {activeStep > 0 && (
            <GKButton
              variant="outlined"
              startIcon={<ArrowLeftIcon />}
              onClick={() => setActiveStep((s) => Math.max(0, s - 1))}
            >
              Back
            </GKButton>
          )}
          {activeStep === steps.length - 1 ? (
            <GKButton
              variant="contained"
              startIcon={<CheckIcon />}
              onClick={() => setOpen(false)}
            >
              Completed
            </GKButton>
          ) : (
            <GKButton
              variant="contained"
              endIcon={<ArrowRightIcon />}
              onClick={() =>
                setActiveStep((s) => Math.min(steps.length - 1, s + 1))
              }
            >
              Next
            </GKButton>
          )}
        </Grid2>
      }
    >
      <Grid2 container spacing={2}>
        <Grid2 size={4}>
          <List
            sx={{
              p: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {steps.map((step, index) => (
              <ListItem
                key={index}
                onClick={() => setActiveStep(index)}
                sx={{
                  padding: "8px",
                  backgroundColor:
                    activeStep === index ? `var(--primary-50)` : "",
                  color: activeStep === index ? `var(--primary-900)` : "",
                  borderRadius: "8px",
                  ":hover": {
                    cursor: "pointer",
                  },
                }}
              >
                <Typography>{step.title}</Typography>
              </ListItem>
            ))}
          </List>
        </Grid2>
        <Grid2 size={8}>
          {steps[activeStep].description}
          {activeStep === 0 && (
            <Box
              mt={1}
              sx={{
                background: "var(--yellow-100)",
                borderRadius: "8px",
                p: "8px",
              }}
            >
              <Typography>
                <Typography
                  component="span"
                  fontSize={12}
                  fontWeight={700}
                  color="var(--neutral-700)"
                >
                  Note:
                </Typography>{" "}
                <Typography
                  component="span"
                  fontSize={12}
                  fontWeight={500}
                  color="var(--neutral-700)"
                >
                  Official Telegram bots have a blue checkmark beside their
                  name.
                </Typography>
              </Typography>
            </Box>
          )}
        </Grid2>
      </Grid2>
    </GKModal>
  );
};

export default TelegramSetupModal;
